import { createReactContext, createReactDispatchContext } from "../../../utils/reactContext";
import { PayeeVendorTaxDocument } from "../CreatePayeeVendorWorkflow/types";
import { PayeeBaseAddress, PayeeBaseSupportingDocument } from "../types";

export type CreatePayeeData = {
  arenaId?: string;
  arenaName?: string;
  payeeName?: string;
  payeeAddress?: PayeeBaseAddress;
  paymentPrefId?: number;
  supportingDocuments?: PayeeBaseSupportingDocument[];

  //Vendor Specific Items
  taxCountryId?: number;
  taxId?: string;
  form1099Required?: boolean;
  notes?: string;
  invoices?: PayeeBaseSupportingDocument[];
  taxDocuments?: PayeeVendorTaxDocument[];
};

export const initialCreatePayeeState: CreatePayeeData = {
  arenaId: undefined,
  arenaName: undefined,
  payeeName: undefined,
  payeeAddress: undefined,
  paymentPrefId: undefined,
  supportingDocuments: undefined,
  taxCountryId: undefined,
  taxId: undefined,
  form1099Required: undefined,
  notes: undefined,
  invoices: undefined,
  taxDocuments: [],
};

export type CreatePayeeReducer = {
  createPayeeData: CreatePayeeData;
  action: CreatePayeeReducerAction;
};

export type CreatePayeeReducerAction = {
  type: string;
  payload: Partial<CreatePayeeData>;
};

export const createPayeeReducer = (
  state: CreatePayeeData,
  action: CreatePayeeReducerAction,
): CreatePayeeData => {
  switch (action.type) {
    case "SET_PAYEE_DETAILS_ENTITY_AND_INVESTMENT": {
      const payeeName = action.payload.payeeName || state.payeeName;
      return {
        ...state,
        payeeName,
      };
    }
    case "SET_PAYEE_DETAILS_VENDOR": {
      return {
        ...state,
        payeeName: action.payload.payeeName,
        taxId: action.payload.taxId,
      };
    }
    case "SET_INVOICES": {
      return {
        ...state,
        invoices: action.payload.invoices,
      };
    }
    case "SET_SUPPORTING_DOCUMENTS": {
      return {
        ...state,
        supportingDocuments: action.payload.supportingDocuments,
      };
    }
    case "SET_CLIENT_DETAILS_ARENA": {
      return {
        ...state,
        arenaName: action.payload.arenaName,
        arenaId: action.payload.arenaId,
      };
    }
    default: {
      return state;
    }
  }
};

const [useCreateBasePayeeReducerContext, CreateBasePayeeReducerContextProvider] =
  createReactContext<CreatePayeeData>();

export { useCreateBasePayeeReducerContext, CreateBasePayeeReducerContextProvider };

const [useCreatePayeeDispatchContext, CreatePayeeReducerDispatchProvider] =
  createReactDispatchContext<CreatePayeeReducerAction>();

export { useCreatePayeeDispatchContext, CreatePayeeReducerDispatchProvider };

export type CreatePayeeStep = {
  stepNumber: number;
};

export type CreatePayeeStepAction = {
  type: string;
};

export const initialCreatePayeeStepState: CreatePayeeStep = {
  stepNumber: 0,
};

export const createPayeeStepReducer = (
  state: CreatePayeeStep,
  action: CreatePayeeStepAction,
): CreatePayeeStep => {
  switch (action.type) {
    case "INCREMENT_STEP": {
      if (state.stepNumber >= 3) {
        return state;
      }
      return {
        stepNumber: state.stepNumber + 1,
      };
    }
    case "DECREMENT_STEP": {
      if (state.stepNumber > 0) {
        return {
          stepNumber: state.stepNumber - 1,
        };
      }
      return state;
    }
    default: {
      return state;
    }
  }
};

const [useCreatePayeeStepContext, CreatePayeeStepContextProvider] =
  createReactContext<CreatePayeeStep>();

export { useCreatePayeeStepContext, CreatePayeeStepContextProvider };

const [useCreatePayeeStepDispatchContext, CreatePayeeStepReducerDispatchProvider] =
  createReactDispatchContext();

export { useCreatePayeeStepDispatchContext, CreatePayeeStepReducerDispatchProvider };
